import { t } from "@/i18n-js/instance";
import { usePlans } from "@circle-react/components/SettingsApp/Plan/RegularPlan/PlansContext";
import { BadgeV2 } from "@circle-react-uikit/BadgeV2";
import { Typography } from "@circle-react-uikit/Typography";

export const CurrentPlan = () => {
  const { currentPlan } = usePlans();

  const { display_name, friendly_base_amount, display_interval } = currentPlan;

  const currentPlanLabel = t("pricing_plans.current_plan_message", {
    preview_name: display_name,
    friendly_base_amount: friendly_base_amount,
    interval: display_interval.toLowerCase(),
  });

  return (
    <div>
      <BadgeV2 square label={t("pricing_plans.current_plan")} />
      <div className="my-1">
        <Typography.TitleSm weight="bold">{display_name}</Typography.TitleSm>
      </div>
      <Typography.BodyMd color="text-default">
        {currentPlanLabel}
      </Typography.BodyMd>
    </div>
  );
};
